<!--
 * @Description: 编辑地图弹窗
 * @Author: mdb
 * @Date: 2023-05-08 10:43:50
 * @LastEditTime: 2023-05-08 16:32:07
 * @LastEditors: mdb
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :width="600"
    :title="modalTitle"
    :confirmLoading="loading"
    destroyOnClose
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :wrapper-col="{ span: 24 }" ref="formRef" :model="dataForm">
      <a-form-item label="地图类型" name="mapType" :rules="formRules.select">
        <a-select v-model:value="dataForm.mapType" :options="mapsEnum" disabled />
      </a-form-item>
      <a-form-item label="地图状态" name="status" :rules="formRules.select">
        <a-select v-model:value="dataForm.status" :fieldNames="{ label: 'name' }" :options="statusEnum" disabled />
      </a-form-item>
      <a-form-item label="Android Key" name="mapAndroidKey">
        <CosInput v-model:value="dataForm.mapAndroidKey" placeholder="请输入" :maxlength="100" />
      </a-form-item>
      <a-form-item label="IOS Key" name="mapIosKey">
        <CosInput v-model:value="dataForm.mapIosKey" placeholder="请输入" :maxlength="100" />
      </a-form-item>
      <a-form-item label="Web Key" name="mapWebKey">
        <CosInput v-model:value="dataForm.mapWebKey" placeholder="请输入" :maxlength="100" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { mapsEnum, statusEnum } from './enum'
import { updateMapConfig } from '@/api/systemSetting/index'
import type { MapListItem, MapListParams } from '@/typings/api/systemSetting'

const initDefaultData = () => ({ mapType: 0, status: 0, mapAndroidKey: '', mapIosKey: '', mapWebKey: '' })
const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = reactive<MapListParams>(initDefaultData())
const formRules = reactive({
  input: [{ required: true, message: '请输入' }],
  select: [{ required: true, message: '请选择' }]
})
const emit = defineEmits(['fetch'])

const mapList = ref<MapListItem[]>([])
const currentIndex = ref<number>(0)
// 弹窗标题
const modalTitle = '编辑地图配置'
const init = (rows: MapListItem, list: MapListItem[]) => {
  mapList.value = list.map((item) => {
    const { mapType, status, mapAndroidKey, mapIosKey, mapWebKey } = item
    return { mapType, status, mapAndroidKey, mapIosKey, mapWebKey }
  })
  currentIndex.value = list.findIndex((item) => item.mapType === rows.mapType)

  const { mapType, status, mapAndroidKey, mapIosKey, mapWebKey } = rows
  Object.assign(dataForm, { mapType, status, mapAndroidKey, mapIosKey, mapWebKey })
  visible.value = true
}

const handleOk = async () => {
  try {
    await formRef.value?.validate()
    loading.value = true
    const params = mapList.value.slice() // 深拷贝
    params.splice(currentIndex.value, 1) // 删除当前项
    params.splice(currentIndex.value, 0, dataForm) // 插入当前项
    await updateMapConfig(params)
    DcMessage.success('操作成功！')
    emit('fetch')
    handleCancel()
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
const handleCancel = () => {
  formRef.value?.resetFields()
  visible.value = false
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'ModalForm' }
</script>

<style scoped></style>
